
import { useState, useCallback } from "react";
import { STALE_TIMES, GC_TIMES } from "@/constants/serviceQueryConstants";
import { isLowDataMode } from "@/utils/networkMonitor";

/**
 * Hook to adjust page size and cache times based on network conditions
 */
export const usePageSizeAdjuster = (initialPageSize: number) => {
  const isLowData = isLowDataMode();
  
  // Adjust page size based on connection type
  const adjustedPageSize = isLowData ? Math.min(initialPageSize, 6) : initialPageSize;
  
  // Get appropriate stale time based on connection
  const getStaleTime = useCallback(() => {
    if (!navigator.onLine) return STALE_TIMES.offline;
    if (isLowData) return STALE_TIMES.lowData;
    return STALE_TIMES.default;
  }, [isLowData]);
  
  // Get appropriate garbage collection time based on connection
  const getGcTime = useCallback(() => {
    if (!navigator.onLine) return GC_TIMES.offline;
    if (isLowData) return GC_TIMES.lowData;
    return GC_TIMES.default;
  }, [isLowData]);

  return {
    adjustedPageSize,
    getStaleTime,
    getGcTime
  };
};
